module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"select.multiple":"Aucune sélection | 1 sélectionné | {count} sélectionnés","search.no.data":"Aucune sélection correspondante","select.check.all":"Tout","select.uncheck.all":"Aucun"}}')
  delete Component.options._Ctor
}
